export default __webpack_public_path__ + "static/media/new_order.d6e50047.svg";